import Model from "./model";

export default new Model({
  resource: "centro-costo",
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"", required: true, type:"text", width: 300},
    {label:"Código", nameAttr:"codigo", default:"", required: true, type:"text", width: 100},
    {label:"C. Agro", nameAttr:"compuagro_id", default:"", required:false, type:"text", width: 100},
    {label:"Empresa", nameAttr:"empresa_id", default:null, required: true, type:"select", model:"empresaModel", searchPath: "nombre", width: 150},
    {
      label        : "Cuarteles",
      nameAttr     : "cuarteles",   // se guardan los datos
      default      : [],
      required     : true,
      map          : "id",          //esto transforma un array de objects en un array de ids con el nombre cuarteles_id [nameAttrMap]
      nameAttrMap  : "cuarteles_id",// como nameAttr, pero despues del mapeado
      type         : "multiSelect",
      model        : "cuartelModel",
      //modelGrouped : true,
      searchPath   : "nombre",
      width        : 300
    },
  ]
});
